import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { addTeamToPartner, getAllPartners } from '../../api/requests';
import SelectDropdown, {
    ISelectDropdownItem
} from '../../components/form-control/SelectDropdown';
import { Partner } from '../../models/partner/Partner';
import { showToast } from '../../utils/miscFunctions';

export interface IAssignTeamToPartner {
    teamId: string;
    managerId: string;
}

const AssignTeamToPartner = ({ onProceed, onClose, teamID }: { onProceed: () => void; onClose: () => void; teamID: string; }) => {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [partners, setPartners] = useState<any>([]);

    useEffect(() => {
        getPartners();
    }, []);

    const getPartners = () => {
        getAllPartners(0, 100)
            .then((response: any) => {
                const _partners = response?.content?.map((_team: any) => {
                    return new Partner(_team);
                });

                setPartners(_partners);

                const from = response.pageable?.offset + 1;
                const to =
                    from + response.size > response.totalElements
                        ? response.totalElements
                        : from + response.size - 1;
            })
            .catch((error: Error) => { })
            .finally(() => {
                setLoading(false);
            });
    };

    const submitHandler = (values: any) => {
        setSubmitting(true);
        const partnerId = values.id

        addTeamToPartner(teamID, partnerId)
            .then((response: any) => {
                showToast.success(response.message ?? 'Team assigned to partner successfully',);
                onProceed();
            })
            .catch((error: any) => {
                showToast.error(error.description);
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <div className="bg-white rounded-xl dark:bg-darkBg">
            <div className="p-[1rem] flex items-start  mt-[26px]">
                <span className=" text-left dark:text-darkBg-mainText">
                    You are about to assign this team a partner.
                </span>
            </div>
            <div className="p-[1rem] w-full">
                <Formik
                    initialValues={{
                        id: ''
                    }}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={Yup.object({
                        // email: Yup.string().email('Email provided invalid.').required('Email is requied.')
                    })}
                    onSubmit={(values) => {
                        submitHandler(values);
                    }}>
                    {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <div className="">
                                <SelectDropdown
                                    label="Select Partner"
                                    name="id"
                                    list={partners?.map((partner: any) => (
                                        {
                                            name: `${partner.name} `,
                                            value: partner.id
                                        }
                                    ))}
                                    listSelectedValue={values.id}
                                    onChange={(val: ISelectDropdownItem | null) => {
                                        setFieldValue('id', val);
                                    }}
                                    onBlur={handleBlur}
                                    placeholder="Select Partner"
                                    error={touched.id ? errors.id : undefined}
                                    helperText={touched?.id ? errors.id : undefined}
                                    required
                                />
                            </div>

                            <div className="w-full flex gap-4 mt-6 !mb-4">
                                <Button
                                    type="button"
                                    label="Cancel"
                                    onClick={onClose}
                                    bgColor='secondary'
                                    fullWidth
                                    loading={submitting}
                                    disabled={submitting}
                                />
                                <Button
                                    type="submit"
                                    label="Submit"
                                    bgColor='primary'
                                    fullWidth
                                    loading={submitting}
                                    disabled={submitting}
                                />
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AssignTeamToPartner;
